import { useTranslation } from "react-i18next";
import { useReferralStatistics } from "../../hooks/api/referrals/useReferralStatistics";
import { formatCompactCurrency } from "../../utils/math";
import { ReferralStat, ReferralStatsWrapper } from "./style";

interface IReferralStatsProps {
  isMobileScreen?: boolean;
}

export function ReferralStats({ isMobileScreen }: IReferralStatsProps) {
  const { data: referralStatsData } = useReferralStatistics();
  const { t } = useTranslation("app", {
    keyPrefix: "pages.ReferralsTab.ReferralsTab",
  });

  return (
    <ReferralStatsWrapper $isMobileScreen={isMobileScreen}>
      <ReferralStat>
        <span>{t("traders_referred")}</span>
        <p>
          {referralStatsData ? referralStatsData?.referred || 0 : "-"}
        </p>
      </ReferralStat>
      <ReferralStat>
        <span>{t("referees_volume")}</span>
        <p>
          {referralStatsData
            ? formatCompactCurrency(
                Number(referralStatsData?.volume || 0)
              )
            : "-"}
        </p>
      </ReferralStat>
      {/* <ReferralStat>
        <span>{t("unclaimed_rewards")}</span>
        <p>
          {referralStatsData
            ? formatCompactCurrency(
                Number(referralStatsData?.total_rewards_unclaimed || 0)
              )
            : "-"}
        </p>
      </ReferralStat> */}
      {/* <ReferralStat>
        <span>{t("total_rewards_earned")}</span>
        <p>
          {referralStatsData
            ? formatCompactCurrency(
                Number(referralStatsData?.total_rewards || 0)
              )
            : "-"}
        </p>
      </ReferralStat> */}
    </ReferralStatsWrapper>
  );
}
